module.exports = __webpack_public_path__ + "static/media/rg.179252d5.png";